import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

/**
 * Create Toggle Context.
 */ const ToggleContext = /*#__PURE__*/ createContext({
    disabled: undefined
});
/**
 * Create Toggle Provider.
 */ const ToggleProvider = ({ disabled = false, children })=>jsx(ToggleContext.Provider, {
        value: {
            disabled
        },
        children: children
    });
ToggleProvider.displayName = 'Toggle.Provider';

export { ToggleContext, ToggleProvider };
//# sourceMappingURL=Toggle.Context.es.js.map
